---
date: 2024-06-16
title: Indoor= in Spanish
---

The indoor= user interface if now available in Spanish, thanks to [Carlos Sánchez López](https://app.transifex.com/user/profile/erielkhan/).

To translate it in your language, [go to the transifex page](https://explore.transifex.com/indoorequal/indoorequalorg/).
